import React, {useState} from 'react';
import {Button} from 'react-bootstrap';

const DefaultTrigger = () => (
	<Button>Default</Button>	
)

const DefaultDropper = () => (
	<div>Hello world</div>
)

const ManateeDropdown = ({ Trigger, Dropper, dropper_container_style, container_style, trigger_props, dropper_props}) => {
	try {
		const default_overlay_style = {
			position: 'fixed',
			width: '100%',
			height: '100%',
			top: 0,
			left: 0
		};

		const default_droppper_container_style = {
			position: 'absolute',
			top: 50,
			left: '-20px',
			zIndex: 100,
			backgroundColor: 'white',
			boxShadow: '0 2px 8px 0 rgba(0,0,0,0.15)',
		}

		const [ show_dropper, set_show_dropper ] = useState(false);

		return (
			<div style={{ position: 'relative', ...container_style }}>
				<div 
					style={{
						...default_overlay_style,
						display: show_dropper ? 'block' : 'none',
						zIndex: 100,
					}}
					onClick={(e) => {set_show_dropper(false); e.stopPropagation();}}
				/>
				<Trigger 
					toggle_dropdown={() => set_show_dropper(!show_dropper)}
					trigger_props={{...trigger_props}}
				/> 
				<div style={{ display: show_dropper ? 'block' : 'none', ...default_droppper_container_style, ...dropper_container_style }}> 
					<Dropper dropper_props={{...dropper_props}} toggle_dropdown={() => set_show_dropper(!show_dropper)}/>
				</div>
			</div>
		);
	} catch(err) {
		console.error(err);
		return null;
	}
};

ManateeDropdown.defaultProps = {
	Trigger: DefaultTrigger,
	Dropper: DefaultDropper,
	container_style: {},
	dropper_container_style: {}
}

export default ManateeDropdown;